/**
 * Shared daterangepicker configuration for the analytics dashboard.
 *
 * One source for the calendar options (preset ranges, month/year dropdowns,
 * RTL locale) so the page filter bar, the compare-pane clones and the mobile
 * filter sheet all open the exact same picker.
 */
export function reportDaterangeOptions(start, end, overrides) {
    // Analytics sets pageVariables; other admin pages (marketing campaigns)
    // fall back to the layout's <html lang>, which follows is_rtl().
    var locale = (window.pageVariables && window.pageVariables.locale) || document.documentElement.lang
    var isRtl = locale === 'ar'

    return Object.assign({
        startDate: start,
        endDate:   end,
        opens:     isRtl ? 'right' : 'left',
        // Month + year select dropdowns in the calendar header, so a
        // far-back period is reachable without arrow-clicking through
        // every month. Data starts in 2022.
        showDropdowns: true,
        minYear: 2022,
        maxYear: moment().year() + 1,
        locale: {
            format:           'MMM D, YYYY',
            applyLabel:       isRtl ? 'تطبيق'  : 'Apply',
            cancelLabel:      isRtl ? 'إلغاء'  : 'Cancel',
            fromLabel:        isRtl ? 'من'     : 'From',
            toLabel:          isRtl ? 'إلى'    : 'To',
            customRangeLabel: isRtl ? 'مخصص'   : 'Custom Range',
            direction:        isRtl ? 'rtl'    : 'ltr',
            daysOfWeek:       isRtl
                ? ['الأح', 'الإث', 'الثل', 'الأر', 'الخم', 'الجم', 'السب']
                : ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
            monthNames: isRtl
                ? ['يناير','فبراير','مارس','أبريل','مايو','يونيو','يوليو','أغسطس','سبتمبر','أكتوبر','نوفمبر','ديسمبر']
                : ['January','February','March','April','May','June','July','August','September','October','November','December'],
        },
        ranges: isRtl ? {
            'اليوم':        [moment(), moment()],
            'أمس':          [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'آخر 7 أيام':  [moment().subtract(6, 'days'), moment()],
            'آخر 30 يومًا': [moment().subtract(29, 'days'), moment()],
            'هذا الشهر':   [moment().startOf('month'), moment().endOf('month')],
            'الشهر الماضي':[moment().subtract(1,'month').startOf('month'), moment().subtract(1,'month').endOf('month')],
            'هذه السنة':   [moment().startOf('year'), moment().endOf('year')],
            'السنة الماضية':[moment().subtract(1,'year').startOf('year'), moment().subtract(1,'year').endOf('year')],
        } : {
            'Today':        [moment(), moment()],
            'Yesterday':    [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Last 7 Days':  [moment().subtract(6, 'days'), moment()],
            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
            'This Month':   [moment().startOf('month'), moment().endOf('month')],
            'Last Month':   [moment().subtract(1,'month').startOf('month'), moment().subtract(1,'month').endOf('month')],
            'This Year':    [moment().startOf('year'), moment().endOf('year')],
            'Last Year':    [moment().subtract(1,'year').startOf('year'), moment().subtract(1,'year').endOf('year')],
        },
    }, overrides || {})
}
